/*

Zone Item List

*/

import React, { useEffect, useState } from "react";
import InputTextSimple from "../../../components/common/InputText/InputTextSimple";
import PlusIcon from ".//..//..//..//assets//images//icons//plus.svg";
// import DropDown from "./DropDown";
import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import Items from ".//..//..//..//assets//images//icons//items.svg";
import ButtonWithIcon from "../../../components/common/buttons/ButtonWithIcon";
import BinIcon from "../../../assets/images/icons/bin.svg";
import ButtonOutlineWithIcon from "../../../components/common/buttons/ButtonOutlineWithIcon";
import Button from "../../../components/common/buttons/Button";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import useAuth from "../../../hooks/useAuth";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const WohnZimmer = () => {
  const [calCount, setCalCount] = useState(125);
  const [zoneName, setZoneName] = useState("");
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const zoneId = queryParams.get("zone-id");

  console.log(zoneId);
  const handleRowClicked = (row) => {
    const zoneItemId = row["id"];

    console.log(`Selected Row Data:\n${JSON.stringify(zoneItemId)}`);
    navigate(`${ROUTES.ADMIN_ZONE_ITEMS_UPDATE}?zone-id=${zoneId}&zone-item-id=${zoneItemId}`);
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "40px",
        background: "#eee",
        marginTop: "0.625rem",
        marginBottom: "0.625rem",
        borderRadius: "1rem",
        border: 0,
        cursor: "pointer",
        boxShadow: "0px 4px 4px 0px rgba(16, 16, 16, 0.10)",
      },
    },

    headCells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
    cells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        whiteSpace: "wrap",
      },
    },
  };

  const columns = [
    {
      name: "id",
      selector: (row) => row.id,
      width: "0rem",
    },
    {
      name: "#",
      selector: (row) => row.count,
      width: "4rem",
    },
    {
      name: <p>Tárgy</p>,
      selector: (row) => row.targy_neve,
      minWidth: "8rem",
    },
    {
      name: <p className="break-words ">Valami amit nem értek</p>,
      selector: (row) => row.dubel_arbeiten,
      width: "7rem",
    },
    {
      name: <p className="break-words">Villany szerelő</p>,
      selector: (row) => row.villanyszerelo,
      width: "7rem",
    },
    {
      name: <p className="break-words">Konyha szerelő</p>,
      selector: (row) => row.konyhaszerelo,
      width: "7rem",
    },
    {
      name: <p className="break-words ">Csomagolási idő /fő</p>,
      selector: (row) => row.csomagolasi_ido,
      width: "7rem",
    },
    {
      name: <p className="break-words">Buborék csomagolási idő /fő</p>,
      selector: (row) => row.buborekcsomagolasi_ido,
      width: "10rem",
    },
    {
      name: <p className="break-words">Kicsomagolási idő /fő</p>,
      selector: (row) => row.kicsomagolasi_ido,
      width: "7rem",
    },

    {
      name: <p className="break-words">Szétszerelési idő /fő</p>,
      selector: (row) => row.szetszerelesi_ido,
      width: "7rem",
    },
    {
      name: <p className="break-words">Összeszerelési idő /fő</p>,
      selector: (row) => row.osszeszerelesi_ido,
      width: "7rem",
    },
    {
      name: "",
      selector: (row) => row.action,
      width: "7rem",
    },
  ];

  const { getAuth, clearAuth } = useAuth();
  const [zoneItems, setZoneItems] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [invalid, setInvalid] = useState(false);

  const handleDeleteClick = (row) => {
    const zoneItemsId = row?.id;
    const token = getAuth()?.bearerToken;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#8CD4F5",
        cancelButtonColor: "#eee",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          HttpHelper.DeleteRequest({
            route: API_ROUTES.ZONE_ITEMS_DELETE,
            id: zoneItemsId,
            token: token,
          })
            .then((result) => {
              if (result.status == 200) {
                fetchData();
                toast.success("Zone item successfully removed !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 404) {
                toast.error("API not found !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 500) {
                toast.error("Server error !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else {
                toast.error("Unknown server error !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((error) => {
              toast.error("Unknown server error !", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            text: "Zone is safe :)",
            icon: "error",
          });
        }
      });
  };

  const fetchData = () => {
    HttpHelper.GetRequest({
      route: `${API_ROUTES.ZONE_ITEMS_LIST}`,
      token: getAuth()?.bearerToken,
      searchQuery: searchText,
      urlParameters: `zoneId=${zoneId}`,
    })
      .then((res) => {
        if (res?.status == 200) {
          setInvalid(true);
          const zoneItemList = res?.data?.zones;
          const zone = res?.data?.zone;
          console.log(zone);
          setZoneName(zone?.nev);
          console.log(zoneItemList);
          const newData = zoneItemList.map((item, index) => ({
            key: index + 1,
            id: item.id,
            count: index + 1,
            targy_neve: <p className="break-words">{item.targy_neve}</p>,
            dubel_arbeiten: <p className="break-words">{item.dubel_arbeiten === 1 ? "Yes" : "No"}</p>,
            villanyszerelo: <p className="break-words">{item.villanyszerelo === 1 ? "Yes" : "No"}</p>,
            konyhaszerelo: <p className="break-words">{item.konyhaszerelo === 1 ? "Yes" : "No"}</p>,
            csomagolasi_ido: <p className="break-words">{item.csomagolasi_ido}</p>,
            buborekcsomagolasi_ido: <p className="break-words">{item.buborekcsomagolasi_ido}</p>,
            kicsomagolasi_ido: <p className="break-words">{item.kicsomagolasi_ido}</p>,
            szetszerelesi_ido: <p className="break-words">{item.szetszerelesi_ido}</p>,
            osszeszerelesi_ido: <p className="break-words">{item.osszeszerelesi_ido}</p>,
            action: (
              <img
                src={BinIcon}
                alt="Bin Icon"
                className="p-[6px]  border-2 border-gray-400 border-solid rounded-full"
                onClick={() => {
                  handleDeleteClick(item);
                }}
              />
            ),
          }));
          console.log(newData);
          setZoneItems(newData);
        } else if (res.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (res.status == 500) {
          setInvalid(false);
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status == 404) {
          setInvalid(false);
          toast.error("Invalid Zone !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setInvalid(false);
          toast.error("Unknown server error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    fetchData();
  }, [searchText]);

  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <div className=" mt-[3rem]  flex flex-row justify-between items-center ">
          <div className="flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
            <Link to={`${ROUTES.ADMIN_ZONE_LIST}`}>
              <i className="bg-[rgba(6,85,103,0.5)] h-[4.3rem] w-[4.3rem] rounded-full flex justify-center items-center">
                <img src={Items} alt="items icon" className="w-[2.5rem] " />
              </i>
            </Link>

            <div>
              <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">{zoneName}</h2>
              <p className="text-[#BDBDBD] text-[1rem] font-bold font-lato">Zónához rendelt tételek</p>
            </div>
          </div>
          <div className="flex flex-row gap-[1.25rem]">
            <span>Létrehozás dátuma</span>
            <span className="font-bold">{new Date().toISOString().slice(0, 10).replaceAll("-", ".")}</span>
          </div>
        </div>
        {/* Header Start */}
        <div className="mt-[3rem] flex flex-col lg:flex-row  justify-between gap-4 ">
          <div className="w-full lg:w-1/4">
            <InputTextSimple
              placeholder={`Tétel keresése`}
              variant="bold"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <div className="flex items-center gap-[1.125rem] ">
            {/* <DropDown /> */}
            {/* <Link to={ROUTES.CAL_MANAGE_CUSTOMER_DATA}>
             
            </Link> */}
            {invalid && (
              <>
                <Button label={`Új zóna hozzáadása`} />

                <Link to={`${ROUTES.ADMIN_ZONE_ITEMS_CREATE}?zone-id=${zoneId}`}>
                  <ButtonOutlineWithIcon label={`Új`} icon={PlusIcon} />
                </Link>
              </>
            )}
          </div>
        </div>
        {/* Header End */}

        {/* Table Start */}
        <div className="mt-[3rem] w-full  ">
          <DataTable columns={columns} data={zoneItems} onRowClicked={handleRowClicked} customStyles={customStyles} />
        </div>
        {/* Table End */}
      </div>
    </>
  );
};

export default WohnZimmer;
